/**
 * @file Purchased Custom Print - Update Status Modal container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import PurchasedCustomPrintUpdateStatusModal from './PurchasedCustomPrintUpdateStatusModal';
import { purchasedCustomPrintUpdate } from '../../../../../../../graphql/mutations/pro-custom-prints';

const withPurchasedCustomPrintUpdateMutation = graphql(
  purchasedCustomPrintUpdate,
  {
    props: ({ mutate }) => ({
      purchasedCustomPrintUpdateMutation: (
        purchasedCustomPrintId,
        orderStatus,
        // To be used on the optimistic response
        purchasedCustomPrint = {},
      ) =>
        mutate({
          variables: {
            input: {
              purchased_custom_print_id: purchasedCustomPrintId,
              order_status: orderStatus,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            purchasedCustomPrintUpdate: {
              __typename: 'PurchasedCustomPrintUpdatePayload',
              purchased_custom_print: {
                ...purchasedCustomPrint,
                id: purchasedCustomPrintId,
                order_status: orderStatus,
              },
            },
          },
        }),
    }),
  },
);

export default compose(
  withRouter,
  withPurchasedCustomPrintUpdateMutation,
)(PurchasedCustomPrintUpdateStatusModal);
